module.exports = __webpack_public_path__ + "static/img/yingyezhizhao.c2b1aac5.png";